<h1 mat-dialog-title>
    {{ 'element.types.iframe.preview.label' | translate }}
</h1>
<div mat-dialog-content>
    <iframe [width]="data.iframe.width" [height]="data.iframe.height" [src]="data.iframe.source | safe: 'resourceUrl'"></iframe>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="warn" (click)="dialogRef.close()">Fermer</button>
</div>
